import React from 'react'
import Hamida_Faculty_Cv from '../../../assets/F_Social_science_Cv/History/Hamida_Faculty_Cv.pdf'
import TeacherCard from '../../../Components/TeacherCard'
import MegaNavbar from '../../../Components/MegaNavbar'
import Footer from '../../../Components/Footer'

const History = () => {
  return (
    <>
     <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>History</h2>
        
        <p>Faculty of History.</p>
      </div>

      <div className="row">

<TeacherCard 
name='Dr. Hamida Bibi'
profile_name='Assistant Professor, Department of History'
intro='Incharge Department of History and Pakistan Studies at Shaheed Benazir Bhutto Women University Peshawar  '
email='dr.hamida@sbbwu.edu.pk'
cv={Hamida_Faculty_Cv}
google='https://www.google.com/'
linkedin=''


/>
      
</div>

</div>
</section>



  <Footer/>
</>
)
}
export default History
